@if (showHeader) {
  <div class="item header">
    <span class="icon"></span>
    <span class="itemwrapper"></span>
    <span class="message">Status</span>
    <span class="invitation">Invitation</span>
    <!-- <span class="accountinfo">Accounts</span> -->
    <span class="employee-id">Employee ID</span>
    @if (wallitBalance) {
      <span class="balance">Wallit Balance</span>
    }
    <span class="balance">Allowance Balance</span>
    <span class="balance">Peer Recognition Balance</span>
    <span class="birthdate">Birth Date</span>
    <span class="employmentdate">Employment Date</span>
    <span class="teamjoindate">Team Join Date</span>
    <span class="role">Role</span>
    <span class="monthly-allowance">Monthly Allowance</span>
    <span class="monthly-allowance">Amount</span>
    <button mat-button></button>
  </div>
}
<div class="item" #item>
  <img #avatar class="icon" />
  <div class="itemwrapper">
    <span class="name">{{ getMemberName(member) }}</span>
    <span class="email">{{ getEmail(member) }}</span>
    @if (!member.isQr) {
      <span class="email">{{ getLoginName(member) }}</span>
    }
  </div>
  <span class="message">{{ getMemberStatusLabel(member) }}</span>
  <span class="invitation" [ngClass]="getInvitationClass(member)">
    {{ getInvitationLabel(member) }}
  </span>
  <!-- <span class="accountinfo">{{ member.accountInfo || '---' }}</span> -->
  <span class="employee-id">{{ member.employeeNumber || '---' }}</span>
  @if (wallitBalance) {
    <span class="balance">{{
      (member.wallitBalance | currency) || '---'
    }}</span>
  }
  <span class="balance allowance-balance">
    <span>{{ (member.balance | currency) || '---' }}</span>
    @if (getAllowanceRefundReservation(member)) {
      <span class="refund-awaiting">
        Refund awaiting funds: ${{ getReservedRefundAmount(member) }}
      </span>
    }
  </span>
  <span class="balance">{{ (member.p2pBalance | currency) || '---' }}</span>
  <span class="birthdate">{{ ($safeNavigationMigration(member.teamuserMetadata?.birthDate) | date : 'mediumDate') || '---' }}</span>
  <span class="employmentdate">{{ (member.employmentDate | date : 'mediumDate') || '---' }}</span>
  <span class="teamjoindate">{{ (member.memberCreatedAt | date : 'mediumDate') || '---' }}</span>
  <span class="role">{{ member.role || '---' }}</span>
  <span class="monthly-allowance">{{ member.canReceiveAllowance ? 'Enabled' : 'Disabled' }}</span>
  <span class="monthly-allowance">{{ getMonthlyAllowanceLabel(member) }}</span>
  @if (allowRestore && isRemovedMember(member)) {
    <button mat-button [disabled]="restoringMember" (click)="$event.stopPropagation(); restoreMember(member)">
      {{ restoringMember ? 'Restoring...' : 'Restore Member' }}
    </button>
  }
  @if (!readOnly) {
    <button
      (click)="$event.stopPropagation()"
      mat-button
      [matMenuTriggerFor]="memberMenu"
      [matMenuTriggerData]="{ member: member }"
      >
      <mat-icon class="more" matTooltip="Actions">more_vert</mat-icon>
    </button>
  }
</div>
<mat-menu #memberMenu="matMenu">
  <ng-template matMenuContent let-item="member">
    <button mat-menu-item (click)="deleteMember(member)">
      {{ isDeactivationPendingSettlement(member) ? 'Finalize Removal' : 'Remove' }}
    </button>
    <button mat-menu-item (click)="resendMember(member)">
      {{ member.message === 'Active' ? 'Send Login Email' : 'Send Invitation Email' }}
    </button>
    <mat-divider></mat-divider>
    <button
      mat-menu-item
      [matMenuTriggerFor]="memberChangeMenu"
      [matMenuTriggerData]="{ member: member }"
      >
      Change
    </button>
    <button mat-menu-item (click)="setProductEligibility(member)">Set Product Eligibility</button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="toggleAdmin(member)" [disabled]="member.role === 'team admin'">
      {{ member.role === 'admin' ? 'Remove as Admin' : 'Add as Admin' }}
    </button>
    <div
      [matTooltip]="mountTooltipMessage()"
      [matTooltipDisabled]="canSendOneTimeRewards()"
      matTooltipPosition="above"
      >
      <button
        [disabled]="!canSendOneTimeRewards()"
        mat-menu-item
        [matMenuTriggerFor]="memberSendMenu"
        [matMenuTriggerData]="{ member: member }"
        >
        Send
      </button>
    </div>
    <button
      mat-menu-item
      [matMenuTriggerFor]="memberAllowanceMenu"
      [matMenuTriggerData]="{ member: member }"
      >
      Allowance
    </button>
  </ng-template>
</mat-menu>
<mat-menu #memberChangeMenu="matMenu">
  <ng-template matMenuContent let-member="member">
    <button mat-menu-item (click)="changeBirthDate(member)">Change Birth Date</button>
    <button mat-menu-item (click)="changeEmploymentDate(member)">Change Employment Date</button>
    <button mat-menu-item (click)="changeEmployeeNumber(member)">Change Employee Number</button>
  </ng-template>
</mat-menu>
<mat-menu #memberAllowanceMenu="matMenu">
  <ng-template matMenuContent let-member="member">
    <button
      [disabled]="!!team.topupDisabled || isDeactivationPendingSettlement(member)"
      mat-menu-item
      (click)="setCustomMonthlyAllowance(member)"
      >
      Set Custom Monthly Allowance
    </button>
    <button
      mat-menu-item
      (click)="changeUserMonthlyAllowance(member)"
      [disabled]="isDeactivationPendingSettlement(member)"
      >
      {{ member.canReceiveAllowance ? 'Disable' : 'Enable' }} monthly allowance
    </button>
    <button mat-menu-item (click)="refundMember(member)" [disabled]="isDeactivationPendingSettlement(member)">
      {{ getAllowanceRefundReservation(member) ? 'View Refund Status' : 'Refund Allowance' }}
    </button>
  </ng-template>
</mat-menu>
<mat-menu #memberSendMenu="matMenu">
  <ng-template matMenuContent let-item="member">
    <button mat-menu-item (click)="rewardMember(member)">One Time Reward</button>
    <button mat-menu-item (click)="p2pTopupMember(member)">Member-to-Member Top Up</button>
  </ng-template>
</mat-menu>
